export const environment = {
  production: true,
  // tslint:disable-next-line:max-line-length
  roburCertificationRequestUrl: 'https://proclient4.beta.biz/BetaTools.ProClient.Web/Services/RoburCertification.svc/RequestRoburCertificateV2',
  contactSalesUrl: 'https://proclient4.beta.biz/BetaTools.ProClient.Web/Services/RoburCertification.svc/ContactSales'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts